import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Skeleton } from '@solid/ui';
import { projectsApi } from '@/lib/api';
import { bestProject } from '@/lib/project-groups';

/**
 * "/" opens a project, not a dashboard (Jesse, 2026-10-07): the one you had
 * open last in this browser, else your first favorite, else the first A–Z.
 * Somebody with no projects gets the projects screen, which says so.
 *
 * The old Dashboard still answers at /dashboard while its staff-only
 * Waiting-on-Solid queue finds a new home (My tasks is in the nav).
 */
export function Home() {
  const { data: projects, isLoading, isError } = useQuery({
    queryKey: ['projects', 'member'],
    queryFn: () => projectsApi.list(),
  });

  if (isLoading) {
    return (
      <div aria-busy className="space-y-4">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-48 rounded-xl" />
      </div>
    );
  }

  const target = isError ? undefined : bestProject((projects ?? []).filter((p: any) => !p.archivedAt));
  return <Navigate to={target ? `/projects/${target.id}` : '/projects'} replace />;
}
